<!--div class=""-->
    <section class="heading">
        <h1>Welcome to Kizano's FinTech!</h1>
        <p>Please enjoy categories of the works I have produced on various channels.</p>
        <p>
            I do my best to provide a written and video version of my content. If you have any questions,
            please feel free to ask me on <a href="https://markizano.net/chat" target="_blank">Discord</a>.
        </p>
    </section>
    <section class="categories row">
@for( category of categories; track category ) {
        <div class="category">
            <a [routerLink]="['/content', category]">
            <div class="category-content">
                <img [src]="'/assets/videos/'+category+'/thumbnail.png'" alt="{{ category }} thumbnail">
                <h3>{{ category }}</h3>
            </div>
            </a>
        </div>
}
    </section>
<!--/div-->
